"use client";

import { forwardRef } from "react";
import { OTPInput } from "input-otp";

import cx from "classnames";

const InputOTP = forwardRef(
  ({ className, containerClassName, ...props }, ref) => (
    <OTPInput
      ref={ref}
      containerClassName={cx(
        "flex items-center gap-2 has-[:disabled]:opacity-50 text-black",
        containerClassName
      )}
      className={cx("disabled:cursor-not-allowed", className)}
      {...props}
    />
  )
);
InputOTP.displayName = "InputOTP";

export default InputOTP;
